import { useState } from 'react';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import anthosLogo from '@/assets/anthoscapital.svg';
import { useMutation } from '@tanstack/react-query';
import { paths } from '@/routes/paths';
import { Navigate, useNavigate } from 'react-router-dom';
import useUserStore from '@/store/useUserStore';
import authApi from '@/api/auth.api';
import { useAnalytics } from '@/hooks/use-analytics';

const Login = () => {
  const [hasLoginError, setHasLoginError] = useState(false);

  const navigate = useNavigate();

  const { user, token } = useUserStore();

  const { trackAuthEvent } = useAnalytics();

  const { mutate } = useMutation({
    mutationFn: authApi.login,
    onSuccess: () => {
      if (user) {
        trackAuthEvent({ user });
      }
      navigate(paths.HOME);
    },
  });

  if (token) {
    return <Navigate to={paths.HOME} replace />;
  }

  const handleResponse = (response: CredentialResponse) => {
    if (response.credential) {
      mutate(response.credential);
      setHasLoginError(false);
    }
  };

  const handleError = () => {
    setHasLoginError(true);
  };

  return (
    <div className="flex flex-col justify-center gap-20 items-center h-[100vh] pb-20">
      <img src={anthosLogo} alt="anthos logo" className="login-page__logo" />
      <div className="flex flex-col items-center w-[22rem] gap-5">
        <div className="flex flex-col items-center gap-3 shadow-custom-shadow w-full p-[1.8rem] rounded-3xl">
          <h1 className="text-lg">Welcome</h1>
          <div className="bg-gray-300 rounded">
            <GoogleLogin onSuccess={handleResponse} onError={handleError} />
          </div>
        </div>
        {hasLoginError && (
          <div className="text-[11px] text-red-400">
            <p>There was an error with your login, please try again.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
